import React, { useEffect, useRef, useState } from "react"
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { fetchGoods, fetchRawsList, fetchSuppliers, setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import moment from "moment";
import { modalsSelector } from "../../selectors";
import { rawListSelector } from "../../selectors/raw";
import { reasonsSelector, suppliersSelector } from "../../selectors/forms";
import { isEmpty } from "lodash";
import { fetchFilials } from "../../action/handbook";
import { fetchWriteOffFormReasons } from "../../action/reasons";
import { styles } from "../goods/styles";
import Loader from "../../components/utils/Loader";

const ChangeLogAccounting = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const data = useSelector(modalsSelector).changeLogAccountingModal;
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const raws = useSelector(rawListSelector);
    const goods = useSelector(state => state.good.list);
    const reasons = useSelector(reasonsSelector);
    const suppliers = useSelector(suppliersSelector);
    const [loading, setLoading] = useState(true);

    const onClose = () => dispatch(setActiveModalAction({ field: 'changeLogAccountingModal', value: null }));

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            
            try {
                const promises = [];
                
                if (isEmpty(raws)) promises.push(dispatch(fetchRawsList()));
                if (isEmpty(points) || points.length < pointsCount) promises.push(dispatch(fetchFilials(null, true)));
                
                if (data.type === 'writeoff') {
                    if (isEmpty(goods)) promises.push(dispatch(fetchGoods()));
                    if (isEmpty(reasons)) promises.push(dispatch(fetchWriteOffFormReasons()));
                }
                
                if (data.type === 'invoice' && isEmpty(suppliers)) promises.push(dispatch(fetchSuppliers()));
                
                if (promises.length > 0) await Promise.all(promises);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };
        
        getData();
    }, [data.type, dispatch, goods, points, pointsCount, raws, reasons, suppliers]);
    
    useOnClickOutside(ref, onClose);

    const renderPointLabel = (point) => {
        if (!point) return '(филиал не найден)';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    const renderRawTitle = (type) => {
        if (type === 'good') return 'Товар';
        if (type === 'raw') return 'Сырье';
        return 'Полуфабрикат'; 
    }

    const renderChangeRow = (dataChange) => {
        if (!dataChange || dataChange.length === 0) return;
    
        const changes = Object.entries(dataChange).flatMap(([field, change]) => {
            if (!field || !change) return [];
    
            switch (field) {
                case 'point': {
                    const newPoint = points.find((point) => point.id === change.new);
                    let text = '';
                    
                    if (!change.old) {
                        text = `Указан филиал ${renderPointLabel(newPoint)}.`;
                    } else {
                        const oldPoint = points.find((point) => point.id === change.old);
                        text = `Филиал изменен с ${renderPointLabel(oldPoint)} на ${renderPointLabel(newPoint)}.`;    
                    }
                    
                    return [{
                        time: change.time ? change.time : null,
                        author: change.username ? change.username : null,
                        text,
                    }];
                }
                case 'date': {
                    let text = '';
                    
                    if (!change.old) {
                        text = `Указана дата ${moment(change.new).format('DD.MM.YYYY HH:mm:ss')}.`;
                    } else {
                        text = `Дата изменена с ${moment(change.old).format('DD.MM.YYYY HH:mm:ss')} на ${moment(change.new).format('DD.MM.YYYY HH:mm:ss')}.`;
                    }
                    
                    return [{
                        time: change.time ? change.time : null,
                        author: change.username ? change.username : null,
                        text,
                    }];
                }
                case 'productsAdd': {
                    return change.map((item) => {
                        const arrNew = item.new.type === 'good' ? goods : raws;
                        let newProduct = arrNew.find((el) => el.id === item.new.id);
                        if (!newProduct || !newProduct.id) newProduct = item.new;
    
                        let text = '';
                        
                        if (!item.old.id) {
                            text = `${renderRawTitle(item.new.type)} ${newProduct.name} добавлен.`;
                        } else {
                            const arrOld = item.old.type === 'good' ? goods : raws;
                            let oldProduct = arrOld.find((el) => el.id === item.old.id);
                            if (!oldProduct || !oldProduct.id) oldProduct = item.old;
                            text = `${renderRawTitle(item.old.type)} ${oldProduct.name} заменен на ${newProduct.name}.`;    
                        }
                        
                        return {
                            time: item.time ? item.time : null,
                            author: item.username ? item.username : null,
                            text,
                        };
                    });
                }
                case 'raws': {
                    return change.map((item) => {
                        let raw = raws.find((el) => el.id === item.id);
                        let text = '';
                        
                        if (!item.old) {
                            text = `${raw.name} ${item.new} шт. добавлен.`;
                        } else {
                            text = `${raw.name} кол-во изменено с ${item.old || 0} на ${item.new} шт. добавлен.`;
                        }
                        
                        return {
                            time: item.time ? item.time : null,
                            author: item.username ? item.username : null,
                            text,
                        };
                    });
                }
                case 'note': {
                    let text = '';
                    
                    if (!change.old) {
                        text = `Добавлено примечание: "${change.new}".`;
                    } else {
                        text = `Примечание изменено с "${change.old}" на "${change.new}".`;
                    }
                    
                    return [{
                        time: change.time ? change.time : null,
                        author: change.username ? change.username : null,
                        text,
                    }];
                }
                case 'number': {
                    let text = '';
                    
                    if (!change.old) {
                        text = `Добавлн номер: ${change.new}.`;
                    } else {
                        text = `Номер изменен с ${change.old} на ${change.new}.`;
                    }
                    
                    return [{
                        time: change.time ? change.time : null,
                        author: change.username ? change.username : null,
                        text,
                    }];
                }
                case 'writeoffreason': {
                    const newReason = reasons.find((item) => item.id === change.new);
                    let text = '';
                    
                    if (!change.old) {
                        text = `Добавлена причина ${(newReason && newReason.id) ? newReason.name : `id: ${change.new}`}.`;
                    } else {
                        const oldReason = reasons.find((item) => item.id === change.old);
                        text = `Причина изменена с ${(oldReason && oldReason.id) ? oldReason.name : `id: ${change.old}`} на ${(newReason && newReason.id) ? newReason.name : `id: ${change.new}`}.`;
                    }
                    
                    return [{
                        time: change.time ? change.time : null,
                        author: change.username ? change.username : null,
                        text,
                    }];
                }
                case 'supplier': {
                    const newSupplier = suppliers.find((item) => item.id === change.new);
                    let text = '';
                    
                    if (!change.old) {
                        text = `Добавлен поставщик ${(newSupplier && newSupplier.id) ? newSupplier.name : `id: ${change.new}`}.`;
                    } else {
                        const oldSupplier = suppliers.find((item) => item.id === change.old);
                        text = `Поставщик изменен с ${(oldSupplier && oldSupplier.id) ? oldSupplier.name : `id: ${change.old}`} на ${(newSupplier && newSupplier.id) ? newSupplier.name : `id: ${change.new}`}.`;
                    }
                    
                    return [{
                        time: change.time ? change.time : null,
                        author: change.username ? change.username : null,
                        text,
                    }];
                }
                case 'deletedProducts': {
                    return change.map((item) => {
                        const arr = item.type === 'good' ? goods : raws;
                        let product = arr.find((el) => el.id === item.id);
                        if (!product || !product.id) product = item;
                        
                        return {
                            time: item.time ? item.time : null,
                            author: item.username ? item.username : null,
                            text: `${renderRawTitle(item.type)} ${product.name} удален.`
                        };
                    });
                }
                case 'products': {
                    return change.map((item) => {
                        const arr = item.type === 'good' ? goods : raws;
                        let product = arr.find((el) => el.id === item.id);
                        let text = '';
    
                        if (item.quantity) text = `${renderRawTitle(item.type)} ${product.name} - изменено кол-во с ${item.quantity.old || 0} на ${item.quantity.new || 0}.`;
                        if (item.price) text = `${renderRawTitle(item.type)} ${product.name} - изменена цена с ${item.price.old || 0} на ${item.price.new || 0}.`;
                        if (item.totalPrice) text = `${renderRawTitle(item.type)} ${product.name} - изменена сумма с ${item.totalPrice.old || 0} на ${item.totalPrice.new || 0}.`;
                        
                        return {
                            time: item.time ? item.time : null,
                            author: item.username ? item.username : null,
                            text,
                        };
                    });
                }
                case 'recalculation': {
                    let text = 'Проведен ручной пересчет инвентаризации.';

                    return {
                        time: change.time ? change.time : null,
                        author: change.username ? change.username : null,
                        text,
                    }
                }
                default: {
                    return [];
                }
            }
        });
        
        return changes.sort((a, b) => {
            if (a.time > b.time) return -1;
            if (a.time < b.time) return 1;
            return 0;
        })
        .map((change) => (
            <div className='dropdown_row_changeLog' style={{ whiteSpace: 'wrap' }}>
                <div style={{ color: '#000' }}>
                    <span style={{ fontWeight: 600 }}>{`${change.time} - `}</span>
                    {`${change.text} Автор изменения: `}
                    <span style={{ fontWeight: 600 }}>{change.author || 'Не указан'}</span>
                </div>
            </div>
        ))    
    };

    const renderChangeLog = () => {
        if (loading) return <div style={styles.formLoading}><Loader text="Загрузка..." /></div>

        const log = data.changeLog || [];

        return(
            <div style={{ position: 'relative' }}>
                <div className='dropdown_row_changeLog' style={{ whiteSpace: 'wrap' }}>
                    <div style={{ color: '#000', fontWeight: 600 }}>{`Дата создания: ${moment(data.created_at).format('DD.MM.YYYY HH:mm')}`}</div>
                </div>
                {Object.entries(log).sort(([dateA, changesA], [dateB, changesB]) => moment(dateB, 'DD.MM.YYYY') - moment(dateA, 'DD.MM.YYYY')).map(([date, item]) => {
                    const { username, time, ...dataChange } = item;
                    return(
                        <div className='dropdown_row_changeLog' style={{ whiteSpace: 'wrap' }}>
                            <div style={{ color: '#000', fontWeight: 600 }}>{`Дата изменения: ${moment(date).format('DD.MM.YYYY')}`}</div>
                            {renderChangeRow(dataChange)}
                        </div>
                    );
                })}
            </div>
        )
    }

    const renderTitle = () => {
        if (!data || !data.type) return '';
        let text = 'инвентаризации';
        if (data.type === 'invoice') text = 'накладной';
        if (data.type === 'writeoff') text = 'списания';
        return `История изменений ${text} №${data.id}`
    }

    return(
        <form>
            <div  className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={ref} className="modal-content" style={ window.innerWidth > 1024 ? {} : { maxHeight: 'calc(100vh - 200px)' }}>
                        <div className="modal-header">
                            <h5 className="modal-title"> {renderTitle()} </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body" style={{ paddingLeft: 0, paddingRight: 0 }}>
                            {renderChangeLog()}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Закрыть</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(ChangeLogAccounting);